import React, { useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Link,
  Button,
  Input,
  Spinner,
  Box,
  Heading,
  Text,
  useToast,
} from "@chakra-ui/react";
import { AccountContext } from "../../context/AccountContext";

const SignUpVerification = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { state } = useLocation();
  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState("");
  const { confirmRegistration, resendConfirmationCode } =
    useContext(AccountContext);
  const { userData } = state;
  const { codeDeliveryDetails, userSub } = JSON.parse(userData);
  const { Destination } = codeDeliveryDetails;

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    confirmRegistration(userSub, verificationCode)
      .then((data) => {
        setLoading(false);
        console.log("Loggen In", data);
        navigate("/");
        toast({
          title: "Account Created.",
          description: "We've created your account for you. Please Sign In",
          status: "success",
          duration: 10000,
          isClosable: true,
          variant: "left-accent",
          position: "top",
        });
      })
      .catch((err) => {
        console.error(err);
        setErrorText(err.message);
        setLoading(false);
      });
  };
  const handleResend = () => {
    resendConfirmationCode(userSub)
      .then((data) => {
        console.log("resendConfirmationCode", data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <Box>
      <Heading mb={4}>Welcome</Heading>
      <Text fontSize="xl" mt={6} mb={2}>
        We have sent a verification code by email to
        <strong> {Destination}</strong>
        <br />
        Enter it below to confirm your account.
      </Text>
      <form onSubmit={onSubmit}>
        <Input
          mt={2}
          mb={2}
          type="text"
          placeholder="Enter Verification Code"
          value={verificationCode}
          onChange={(event) => setVerificationCode(event.target.value)}
        />

        <Button
          mt={2}
          mb={2}
          type="submit"
          size="sm"
          colorScheme="blue"
          disabled={loading || verificationCode.length === 0}
        >
          {loading ? <Spinner size="sm" mr={2} /> : null}
          Confirm Account
        </Button>
        <Text fontSize="xs" color="red">
          {errorText}
        </Text>
      </form>

      <Text mt={6}>
        Didn't receive a verification code?
        <br />
        <Link onClick={handleResend}>Resend it</Link>
      </Text>
    </Box>
  );
};

export default SignUpVerification;
